import { useState, useEffect, useCallback, useRef } from 'react';
import { useUserBlob, UserBlobErrorBanner } from '../hooks/useUserBlob';

// ─── Period definitions ────────────────────────────────────────────────────────
const PERIODS = [
  { key: 'p10-fy26', label: 'P10 FY26', date: '2026-04-13', fy: 26, period: 10, wip: true,  url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNDBNa3d6TkVsVldFTldXRXBJTWxsUU5rRlJWVWszU0RORVJTWmpQU1V5UmcifQ%3D%3D' },
  { key: 'p9-fy26',  label: 'P9 FY26',  date: '2026-03-16', fy: 26, period: 9,  wip: false, url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNVpWMHN5VXpKUFZrMVVXRVpCUzBOU1RVWkRNMGMwV2pSSFRTWmpQU1V5UmcifQ%3D%3D' },
  { key: 'p8-fy26',  label: 'P8 FY26',  date: '2026-02-11', fy: 26, period: 8,  wip: false, url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNDJRMDh5VTBwS05scFBVVUpFV1ZjM1ZEWktUVXBVUkZwVFN5WmpQU1V5UmcifQ%3D%3D' },
  { key: 'p6-fy26',  label: 'P6 FY26',  date: '2025-12-12', fy: 26, period: 6,  wip: false, url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNDFRVWxMVlZsS1FUZEtTMDVHTWxCSFNWVlJOelZZVDBJMFJpWmpQU1V5UmcifQ%3D%3D' },
  { key: 'p5-fy26',  label: 'P5 FY26',  date: '2025-11-05', fy: 26, period: 5,  wip: false, url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNDJSMVUzVjBsS1RrWlpSRUpHTTA1RVVFeFlWME15VVVwVlV5WmpQU1V5UmcifQ%3D%3D' },
  { key: 'p4-fy26',  label: 'P4 FY26',  date: '2025-10-08', fy: 26, period: 4,  wip: false, url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNVpWelJIVVZKQ05WRkNTbFpFV1ZGUE5EWkJSMDQwVWtrM1RTWmpQU1V5UmcifQ%3D%3D' },
  { key: 'p3-fy26',  label: 'P3 FY26',  date: '2025-09-11', fy: 26, period: 3,  wip: false, url: null },
  { key: 'p11-fy25', label: 'P11 FY25', date: '2025-05-14', fy: 25, period: 11, wip: false, url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNDJOMUl5UmpOVk16TllTVFZCU1ZWWlRsVk1SRlpEV1U5SVJpWmpQU1V5UmcifQ%3D%3D' },
  { key: 'p9-fy25',  label: 'P9 FY25',  date: '2025-03-12', fy: 25, period: 9,  wip: false, url: 'https://loop.cloud.microsoft/p/eyJ1IjoiaHR0cHM6Ly9tYWphbnMuc2hhcmVwb2ludC5jb20vY29udGVudHN0b3JhZ2UvQ1NQXzViOGM1YWFhLTVkMTktNDhjMC04ZDIwLTRmYTMwMmRhOGZlYT9uYXY9Y3owbE1rWmpiMjUwWlc1MGMzUnZjbUZuWlNVeVJrTlRVQ1UxUmpWaU9HTTFZV0ZoSlRKRU5XUXhPU1V5UkRRNFl6QWxNa1E0WkRJd0pUSkVOR1poTXpBeVpHRTRabVZoSm1ROVlpVXlNWEZzY1UxWGVHeGtkMFZwVGtsRkpUSkVha0YwY1ZBMmJ6bGhNekYwVjBoak5VOXBhMk5tYkZWRE5sTkdTVFpuVUhnMmRVTk1XVkp3SlRWR1pGbGhZbEJ4ZDFkdEptWTlNREZhVERaV00wNDJOa0pCVkZKUlZrdEZUVTVDV2pKUFFrZEhXRTFKUTBOVlR5WmpQU1V5UmcifQ%3D%3D' },
];

// ─── KPI definitions ──────────────────────────────────────────────────────────
const KPI_DEFS = [
  { key: 'volumeAccuracy', label: 'Volume Accuracy', unit: '%', target: 75, targetLabel: '≥75% fams ±5%', higherIsBetter: true },
  { key: 'marginAccuracy', label: 'Margin Accuracy', unit: '%', target: 75, targetLabel: '≥75% fams ±5%', higherIsBetter: true },
  { key: 'forecastError',  label: 'Forecast Error',  unit: '%', target: null, targetLabel: 'Improving',    higherIsBetter: false },
  { key: 'forecastBias',   label: 'Forecast Bias',   unit: '%', target: 2,   targetLabel: '<±2%',          higherIsBetter: false, isBias: true },
  { key: 'difot',          label: 'DIFOT',            unit: '%', target: 95,  targetLabel: '≥95%',          higherIsBetter: true },
];

const RAG_COLORS = {
  G: { bg: 'var(--success-soft)', border: 'var(--success)', text: 'var(--success)', label: 'Green' },
  A: { bg: 'var(--warn-soft)',    border: 'var(--warn)',    text: 'var(--warn-text)', label: 'Amber' },
  R: { bg: 'var(--danger-soft)',  border: 'var(--danger)',  text: 'var(--danger)',  label: 'Red'   },
  '-': { bg: 'var(--bg-input)',   border: 'var(--border-soft)', text: 'var(--text-muted)', label: '—' },
};

const ISSUE_RAG = ['R', 'A', 'G'];
const ISSUE_STATUS = ['Open', 'In Progress', 'Resolved'];

// ─── Default data shape ───────────────────────────────────────────────────────
function defaultData() {
  return {
    sixBox: { keyAssumptions: '', changesInAssumptions: '', opportunities: '', vulnerabilities: '', decisionsMade: '', decisionsRequired: '' },
    kpis: { volumeAccuracy: '', marginAccuracy: '', forecastError: '', forecastBias: '', difot: '' },
    issues: [],
  };
}

// Phase 9: data persists per-user per-period in commercial.UserBlob.
// Legacy localStorage `dr-${periodKey}` keys are migrated on first read.
function loadLegacyDR(periodKey) {
  try {
    const raw = localStorage.getItem(`dr-${periodKey}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    try { localStorage.removeItem(`dr-${periodKey}`); } catch { /* ignore */ }
    return parsed;
  } catch { return null; }
}

// ─── RAG calculation ──────────────────────────────────────────────────────────
function calcRag(def, value) {
  const v = parseFloat(value);
  if (isNaN(v)) return '-';
  if (def.isBias) return Math.abs(v) <= def.target ? 'G' : Math.abs(v) <= def.target * 1.5 ? 'A' : 'R';
  if (def.target == null) return '-';
  if (def.higherIsBetter) return v >= def.target ? 'G' : v >= def.target * 0.9 ? 'A' : 'R';
  return v <= def.target ? 'G' : v <= def.target * 1.1 ? 'A' : 'R';
}

function formatDate(d) {
  return new Date(d).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
}

function nextId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}

// ─── Sub-components ───────────────────────────────────────────────────────────

function RagDot({ rag }) {
  const c = RAG_COLORS[rag] || RAG_COLORS['-'];
  return (
    <span style={{
      display: 'inline-block', width: 10, height: 10, borderRadius: '50%',
      background: c.text, flexShrink: 0,
    }} />
  );
}

function RagBadge({ rag }) {
  const c = RAG_COLORS[rag] || RAG_COLORS['-'];
  return (
    <span style={{
      display: 'inline-block', background: c.bg, border: `1px solid ${c.border}`,
      color: c.text, borderRadius: 4, padding: '1px 7px', fontSize: 11, fontWeight: 700,
    }}>
      {c.label}
    </span>
  );
}

// Six Box cell
function SixBoxCell({ label, value, onChange, color }) {
  const borderColor = color === 'green' ? 'var(--success)' : color === 'red' ? 'var(--danger)' : 'var(--text-muted)';
  return (
    <div style={{
      background: 'var(--bg-input)', border: `1px solid ${borderColor}`,
      borderRadius: 6, padding: 12, display: 'flex', flexDirection: 'column', gap: 6,
    }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
        {label}
      </div>
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={`Enter ${label.toLowerCase()}…`}
        style={{
          background: 'transparent', border: 'none', outline: 'none', resize: 'vertical',
          color: 'var(--text-body)', fontSize: 12, lineHeight: 1.6, minHeight: 80,
          fontFamily: 'inherit', width: '100%',
        }}
      />
    </div>
  );
}

// KPI card
function KpiCard({ def, value, onChange }) {
  const rag = calcRag(def, value);
  const c = RAG_COLORS[rag];
  return (
    <div style={{
      background: 'var(--bg-card)', border: `1px solid ${rag !== '-' ? c.border : 'var(--border)'}`,
      borderRadius: 8, padding: '14px 16px', flex: 1, minWidth: 140,
    }}>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 6 }}>{def.label}</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <input
          type="number"
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="—"
          style={{
            background: 'var(--bg-input)', border: '1px solid var(--border-soft)',
            borderRadius: 4, padding: '4px 8px', color: 'var(--text-primary)',
            fontSize: 20, fontWeight: 700, width: 90, outline: 'none',
          }}
        />
        <span style={{ color: 'var(--text-muted)', fontSize: 14 }}>{def.unit}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{def.targetLabel}</span>
        <RagBadge rag={rag} />
      </div>
    </div>
  );
}

// Issues row
function IssueRow({ issue, onChange, onDelete }) {
  const c = RAG_COLORS[issue.rag] || RAG_COLORS['-'];
  const inp = {
    background: 'var(--bg-input)', border: '1px solid var(--border-soft)',
    borderRadius: 4, padding: '4px 8px', color: 'var(--text-body)',
    fontSize: 12, outline: 'none', width: '100%',
  };
  return (
    <tr>
      <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
        <select
          value={issue.rag}
          onChange={e => onChange({ ...issue, rag: e.target.value })}
          style={{ ...inp, width: 80, background: c.bg, color: c.text, border: `1px solid ${c.border}`, fontWeight: 700, fontSize: 11 }}
        >
          {ISSUE_RAG.map(r => <option key={r} value={r}>{RAG_COLORS[r].label}</option>)}
        </select>
      </td>
      <td style={{ padding: '6px 8px', verticalAlign: 'middle', width: '40%' }}>
        <input
          value={issue.description}
          onChange={e => onChange({ ...issue, description: e.target.value })}
          placeholder="Issue description…"
          style={inp}
        />
      </td>
      <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
        <input
          value={issue.owner}
          onChange={e => onChange({ ...issue, owner: e.target.value })}
          placeholder="Owner"
          style={{ ...inp, width: 100 }}
        />
      </td>
      <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
        <input
          type="date"
          value={issue.dueDate}
          onChange={e => onChange({ ...issue, dueDate: e.target.value })}
          style={{ ...inp, width: 130 }}
        />
      </td>
      <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
        <select
          value={issue.status}
          onChange={e => onChange({ ...issue, status: e.target.value })}
          style={{ ...inp, width: 100 }}
        >
          {ISSUE_STATUS.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </td>
      <td style={{ padding: '6px 8px', verticalAlign: 'middle', textAlign: 'center' }}>
        <button
          onClick={onDelete}
          style={{ background: 'none', border: 'none', color: 'var(--danger)', cursor: 'pointer', fontSize: 16, padding: '0 4px' }}
          title="Remove"
        >×</button>
      </td>
    </tr>
  );
}

// ─── Main component ────────────────────────────────────────────────────────────
export default function DR() {
  const [selectedKey, setSelectedKey] = useState('p10-fy26');
  const [data, setData] = useState(defaultData);
  const [saved, setSaved] = useState(false);

  const period = PERIODS.find(p => p.key === selectedKey);

  // Phase 9: per-period blob fetched from API; tracks the currently selected
  // period via dynamic key. useQuery refetches when fullKey changes.
  // API key uses `:` not `/` because the user-blob route only matches a
  // single path segment. (Legacy localStorage uses `dr-{key}` — see
  // loadLegacyDR.) The previous `dr/{key}` shape was broken — every save
  // returned 404 and the mutation silently swallowed the error.
  const fullKey = `dr:${selectedKey}`;
  const blob = useUserBlob(fullKey);
  const hydratedKeyRef = useRef(null);

  // Hydrate (or re-hydrate when selectedKey changes)
  useEffect(() => {
    if (blob.data === undefined) return;
    if (hydratedKeyRef.current === fullKey) return;
    hydratedKeyRef.current = fullKey;

    if (blob.data !== null) {
      setData({ ...defaultData(), ...blob.data });
      return;
    }

    // No DB row for this period — try legacy localStorage migration
    const legacy = loadLegacyDR(selectedKey);
    if (legacy) {
      const merged = { ...defaultData(), ...legacy };
      setData(merged);
      blob.save(merged);
    } else {
      setData(defaultData());
    }
  }, [blob.data, fullKey, selectedKey, blob]);

  // Reset hydration tracking when the user switches periods so the next
  // blob.data fetch triggers a re-hydrate.
  useEffect(() => {
    if (hydratedKeyRef.current !== fullKey) {
      hydratedKeyRef.current = null;
    }
  }, [selectedKey, fullKey]);

  // Autosave (debounced via the hook) — fires only after hydration of THIS key.
  useEffect(() => {
    if (hydratedKeyRef.current !== fullKey) return;
    blob.scheduleSave(data);
    setSaved(true);
    const t = setTimeout(() => setSaved(false), 1500);
    return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, fullKey]);

  const setSixBox = useCallback((field, value) => {
    setData(d => ({ ...d, sixBox: { ...d.sixBox, [field]: value } }));
  }, []);

  const setKpi = useCallback((field, value) => {
    setData(d => ({ ...d, kpis: { ...d.kpis, [field]: value } }));
  }, []);

  const addIssue = useCallback(() => {
    setData(d => ({
      ...d,
      issues: [...d.issues, { id: nextId(), description: '', rag: 'A', owner: '', dueDate: '', status: 'Open' }],
    }));
  }, []);

  const updateIssue = useCallback((id, updated) => {
    setData(d => ({ ...d, issues: d.issues.map(i => i.id === id ? updated : i) }));
  }, []);

  const deleteIssue = useCallback((id) => {
    setData(d => ({ ...d, issues: d.issues.filter(i => i.id !== id) }));
  }, []);

  const card = { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8 };
  const sectionHead = { fontSize: 11, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' };
  const thStyle = { padding: '8px', fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textAlign: 'left', borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap' };

  const fy26 = PERIODS.filter(p => p.fy === 26);
  const fy25 = PERIODS.filter(p => p.fy === 25);

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>

      {/* Load-failure banner — silent-fail bug fix (Phase 15). */}
      <UserBlobErrorBanner blob={blob} noun="demand review plan" hydrated={hydratedKeyRef.current === fullKey} />

      {/* ── Header ── */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, gap: 16, flexWrap: 'wrap' }}>
        <div>
          <h2 style={{ margin: 0, color: 'var(--text-primary)', fontSize: 20, fontWeight: 700 }}>Demand Review</h2>
          <p style={{ margin: '4px 0 0', color: 'var(--text-muted)', fontSize: 13 }}>
            IBP monthly cycle · Oliver Wight methodology
          </p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          {saved && <span style={{ fontSize: 11, color: 'var(--success)' }}>Saved</span>}
          {/* Period tabs */}
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            {fy26.map(p => (
              <button
                key={p.key}
                onClick={() => setSelectedKey(p.key)}
                style={{
                  padding: '5px 12px', borderRadius: 6, fontSize: 12, cursor: 'pointer',
                  fontWeight: selectedKey === p.key ? 700 : 400,
                  background: selectedKey === p.key ? 'var(--info)' : 'var(--bg-input)',
                  color: selectedKey === p.key ? '#fff' : 'var(--text-body)',
                  border: selectedKey === p.key ? '1px solid var(--info)' : '1px solid var(--border-soft)',
                }}
              >
                {p.label}
                {p.wip && <span style={{ marginLeft: 5, fontSize: 10, color: 'var(--warn)', fontWeight: 700 }}>WIP</span>}
              </button>
            ))}
          </div>
          <div style={{ width: 1, height: 24, background: 'var(--border-soft)' }} />
          <select
            value={selectedKey}
            onChange={e => setSelectedKey(e.target.value)}
            style={{
              background: 'var(--bg-input)', border: '1px solid var(--border-soft)',
              borderRadius: 6, padding: '5px 10px', color: 'var(--text-body)', fontSize: 12, cursor: 'pointer',
            }}
          >
            <optgroup label="FY26">{fy26.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}</optgroup>
            <optgroup label="FY25">{fy25.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}</optgroup>
          </select>
          {period?.url && (
            <a href={period.url} target="_blank" rel="noreferrer" style={{
              display: 'inline-flex', alignItems: 'center', gap: 5,
              background: 'var(--bg-input)', border: '1px solid var(--border-soft)',
              color: 'var(--text-body)', textDecoration: 'none',
              borderRadius: 6, padding: '5px 12px', fontSize: 12,
            }}>
              Loop ↗
            </a>
          )}
        </div>
      </div>

      {/* ── Period subheader ── */}
      <div style={{ ...card, padding: '12px 18px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)' }}>{period?.label}</div>
        <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>{period && formatDate(period.date)}</div>
        {period?.wip && (
          <span style={{
            background: 'var(--warn-soft)', border: '1px solid var(--warn-border)', color: 'var(--warn-text)',
            borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 700,
          }}>Work in Progress</span>
        )}
        <div style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)' }}>
          All changes saved automatically to this browser
        </div>
      </div>

      {/* ── DR Scorecard KPIs ── */}
      <div style={{ ...card, padding: '16px 18px', marginBottom: 16 }}>
        <div style={{ ...sectionHead, marginBottom: 14 }}>DR Scorecard</div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {KPI_DEFS.map(def => (
            <KpiCard
              key={def.key}
              def={def}
              value={data.kpis[def.key]}
              onChange={v => setKpi(def.key, v)}
            />
          ))}
        </div>
      </div>

      {/* ── Six Box ── */}
      <div style={{ ...card, padding: '16px 18px', marginBottom: 16 }}>
        <div style={{ ...sectionHead, marginBottom: 14 }}>Six Box — One Page Summary</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridTemplateRows: 'auto auto', gap: 10 }}>
          <SixBoxCell label="Key Assumptions"              value={data.sixBox.keyAssumptions}       onChange={v => setSixBox('keyAssumptions', v)}       color="neutral" />
          <SixBoxCell label="Opportunities"                value={data.sixBox.opportunities}         onChange={v => setSixBox('opportunities', v)}         color="green"   />
          <SixBoxCell label="Decisions Made"               value={data.sixBox.decisionsMade}         onChange={v => setSixBox('decisionsMade', v)}         color="neutral" />
          <SixBoxCell label="Changes in Assumptions"       value={data.sixBox.changesInAssumptions}  onChange={v => setSixBox('changesInAssumptions', v)}  color="neutral" />
          <SixBoxCell label="Vulnerabilities"              value={data.sixBox.vulnerabilities}       onChange={v => setSixBox('vulnerabilities', v)}       color="red"     />
          <SixBoxCell label="Decisions Required"           value={data.sixBox.decisionsRequired}     onChange={v => setSixBox('decisionsRequired', v)}     color="neutral" />
        </div>
      </div>

      {/* ── Issues & Actions Register ── */}
      <div style={{ ...card, padding: '16px 18px', marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          <div style={sectionHead}>Issues &amp; Actions Register</div>
          <button
            onClick={addIssue}
            style={{
              background: 'var(--info-soft)', border: '1px solid var(--info-border)', color: 'var(--info)',
              borderRadius: 6, padding: '5px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
            }}
          >
            + Add Issue
          </button>
        </div>
        {data.issues.length === 0 ? (
          <div style={{ color: 'var(--text-muted)', fontSize: 13, textAlign: 'center', padding: '24px 0' }}>
            No issues logged for this period. Click &quot;+ Add Issue&quot; to begin.
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={thStyle}>RAG</th>
                  <th style={thStyle}>Issue / Action</th>
                  <th style={thStyle}>Owner</th>
                  <th style={thStyle}>Due Date</th>
                  <th style={thStyle}>Status</th>
                  <th style={thStyle} />
                </tr>
              </thead>
              <tbody>
                {data.issues.map(issue => (
                  <IssueRow
                    key={issue.id}
                    issue={issue}
                    onChange={updated => updateIssue(issue.id, updated)}
                    onDelete={() => deleteIssue(issue.id)}
                  />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ── Archive ── */}
      <div style={{ ...card, padding: '16px 18px' }}>
        <div style={{ ...sectionHead, marginBottom: 14 }}>Loop Document Archive</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 8 }}>
          {PERIODS.map(p => (
            <div key={p.key} style={{
              background: 'var(--bg-input)', border: `1px solid ${p.key === selectedKey ? 'var(--info)' : 'var(--border-soft)'}`,
              borderRadius: 6, padding: '10px 12px',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-primary)' }}>{p.label}</span>
                {p.wip && <span style={{ fontSize: 10, color: 'var(--warn)', fontWeight: 700 }}>WIP</span>}
              </div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 6 }}>{formatDate(p.date)}</div>
              {p.url
                ? <a href={p.url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: 'var(--info)', textDecoration: 'none' }}>Open in Loop ↗</a>
                : <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>No link</span>
              }
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}
